var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-lg p-3 mx-auto mt-4 -mb-1 text-center text-white rounded bg-primary"},[_c('h2',{staticClass:"text-white"},[_vm._v("\n        "+_vm._s(_vm.$t('flytipping.report_not_sent'))+"\n    ")]),_vm._v("\n    "+_vm._s(_vm.$t('flytipping.report_not_sent_verify'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }